import React from "react";
import ReactDOM from "react-dom";

const BottomPopover = (props: any) => {
  const {
    isOpen,
    onClose,
    children,
    rootClassName = "",
    backdropClassName = "",
    sheetClassName = "",
  } = props;

  if (typeof document === "undefined" || !isOpen) return null;

  const target = document.body as HTMLElement;

  return ReactDOM.createPortal(
    <div className={`B-mobile-popover ${rootClassName}`} onClick={(e) => e.stopPropagation()}>
      <div
        className={`B-mobile-popover-backdrop ${backdropClassName}`}
        onClick={onClose}
      />
      <div className={`B-mobile-popover-sheet ${sheetClassName}`}>
        {children}
      </div>
    </div>,
    target
  );
};

export default BottomPopover;

